(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ergonomik-discount-note"] && !Shopify.designMode) return;
  try {
    (() => {
  const messages = document.getElementById('ergo-discount-messages')?.dataset;
  if (!messages) return;
  const selector = '.xb_slide_cart_discount_code_input';
  let code = '', text = '', generation = 0, timer, lastSignature = '';
  const normalize = value => String(value || '').trim().toUpperCase();
  function applications(cart) {
    const all = [...(cart.cart_level_discount_applications || [])];
    for (const item of cart.items || []) for (const allocation of item.line_level_discount_allocations || []) {
      if (allocation.amount > 0) all.push(allocation.discount_application);
    }
    return [...new Map(all.filter(Boolean).map(a => [a.key || a.type + ':' + a.title, a])).values()];
  }
  function describe(application) {
    const percentage = Number(application.value);
    return application.value_type === 'percentage' && percentage > 0
      ? `${percentage.toLocaleString('es-MX')}% (${application.title})` : application.title;
  }
  function result(cart, entered) {
    const discounts = applications(cart);
    const appliedCode = discounts.some(a => a.type === 'discount_code' && normalize(a.title) === normalize(entered));
    const current = discounts.map(describe).join(', ');
    if (appliedCode) return messages.applied.replace('__DISCOUNT__', current) + ' ' + messages.rule;
    if (current) return messages.kept.replace('__DISCOUNT__', current) + ' ' + messages.rule;
    return messages.none;
  }
  function render() {
    for (const field of document.querySelectorAll(selector)) {
      let note = field.parentElement.querySelector('[data-ergo-discount-note]');
      if (!note) {
        note = document.createElement('p'); note.dataset.ergoDiscountNote = '';
        note.setAttribute('role', 'status'); note.setAttribute('aria-live', 'polite');
        note.className = 'ergo-discount-note'; field.after(note);
      }
      const next = text || messages.rule;
      if (note.textContent !== next) note.textContent = next;
    }
  }
  async function refresh(version) {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (version !== generation) return;
      text = result(cart, code); render();
    } catch (_) { if (version === generation) { text = messages.retry; render(); } }
  }
  function schedule() {
    clearTimeout(timer);
    if (code) timer = setTimeout(() => refresh(generation), 650);
  }
  function start(field) {
    const input = field.querySelector('textarea,input');
    const value = input?.value.trim();
    if (!value) return;
    code = value; generation++; text = messages.checking; render();
    const version = generation;
    for (const delay of [1200, 3000, 7000]) setTimeout(() => { if (version === generation) refresh(version); }, delay);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest(selector + ' button');
    if (button) start(button.closest(selector));
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && !event.isComposing && event.target.matches(selector + ' textarea,' + selector + ' input')) start(event.target.closest(selector));
  }, true);
  document.addEventListener('cart:change', schedule);
  document.addEventListener('cart:refresh', schedule);
  new MutationObserver(records => {
    if (records.every(r => r.target.parentElement?.closest('[data-ergo-discount-note]') || r.target.closest?.('[data-ergo-discount-note]'))) return;
    render();
    const field = document.querySelector(selector);
    const signature = field?.parentElement.textContent.replace(text, '') || '';
    if (signature !== lastSignature) { lastSignature = signature; schedule(); }
  }).observe(document.body, {childList:true,subtree:true,characterData:true});
  render();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ergonomik-minimum-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('ergonomik-minimum-config').dataset;
  const suppliers = new Set(['OFFIHO', 'BLACK', 'COLOS']);
  const minimum = price => {
    if (!Number.isSafeInteger(price) || price <= 0) return null;
    if (price >= 310000) return 1;
    const upper = Math.ceil(310000 / price);
    const lower = upper - 1;
    return lower >= 1 && 310000 - lower * price <= 10000 ? lower : upper;
  };
  const label = quantity => (Number(quantity) === 1 ? config.labelOne : config.label).replace('__Q__', quantity);
  class MinimumProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form') || document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.controller = new AbortController();
      this.form.addEventListener('variant:change', event => this.update(event.detail.variant?.id), {signal:this.controller.signal});
      this.form.addEventListener('submit', event => {
        this.update(this.form.elements.namedItem('id')?.value || this.dataset.variant);
        if (!this.quantity.checkValidity()) {
          event.preventDefault(); event.stopImmediatePropagation(); this.quantity.reportValidity();
        }
      }, {capture:true, signal:this.controller.signal});
      this.update(this.form.elements.namedItem('id')?.value || this.dataset.variant);
    }
    disconnectedCallback() { this.controller?.abort(); }
    update(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      let input = Array.from(this.form.elements).find(item => item.name === 'quantity');
      if (!input) {
        input = document.createElement('input'); input.type = 'number'; input.name = 'quantity';
        input.className = 'quantity-input'; input.setAttribute('aria-label', 'Cantidad');
        this.prepend(input);
      }
      this.quantity = input;
      const required = variant ? minimum(variant.price) : null;
      const oldMinimum = Number(input.min || 1);
      input.min = String(required || 1); input.dataset.ergoMinimum = input.min;
      const changed = this.currentId !== id;
      if (changed && (!this.currentId || Number(input.value) <= oldMinimum)) input.value = input.min;
      else if (!Number.isInteger(Number(input.value)) || Number(input.value) < Number(input.min)) input.value = input.min;
      if (variant?.max !== null && variant?.max !== undefined) input.max = String(variant.max);
      else input.removeAttribute('max');
      const impossible = required === null || !variant?.available || (variant.max !== null && variant.max < required);
      input.setCustomValidity(impossible ? config.unavailable : '');
      this.querySelector('[data-minimum-message]').textContent = impossible ? config.unavailable : label(required);
      this.currentId = id;
      syncMinus(input);
    }
  }
  function syncMinus(input) {
    const minus = input.closest('quantity-selector')?.querySelector('button');
    if (minus) minus.disabled = Number(input.value) <= Number(input.min || 1);
  }
  function clamp(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-ergo-minimum')) return;
    if (input.value === '' && event.type === 'input') return;
    const required = Number(input.dataset.ergoMinimum);
    if (!Number.isInteger(Number(input.value)) || Number(input.value) < required) input.value = String(required);
    syncMinus(input);
  }
  document.addEventListener('input', clamp, true);
  document.addEventListener('change', clamp, true);
  const productCache = new Map();
  const pendingRows = new WeakSet();
  async function syncXboost(row) {
    const input = row.querySelector('input.xb_slide_cart_product_content_input');
    const link = row.querySelector('a.xb_slide_cart_product_title');
    if (!input || !link || pendingRows.has(row)) return;
    const title = row.querySelector('span.xb_slide_cart_product_variant')?.textContent.trim() || 'Default Title';
    const handle = new URL(link.href, location.href).pathname.split('/products/')[1]?.split('/')[0];
    if (!handle) return;
    const signature = handle + '|' + title;
    const buttons = Array.from(row.querySelectorAll('button.xb_slide_cart_product_button_quantity'));
    if (input.dataset.ergoSignature === signature) {
      if (buttons[0]) buttons[0].disabled = Number(input.value) <= Number(input.min || 1);
      return;
    }
    pendingRows.add(row);
    input.readOnly = true;
    buttons.forEach(button => button.disabled = true);
    try {
      if (!productCache.has(handle)) productCache.set(handle, fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js', {cache:'no-store'}).then(response => {if (!response.ok) throw new Error('Product unavailable'); return response.json();}));
      const product = await productCache.get(handle);
      const variant = product.variants.find(v => v.title === title) || (product.variants.length === 1 ? product.variants[0] : null);
      const restricted = suppliers.has(String(product.vendor).trim().toUpperCase());
      const required = restricted ? minimum(variant?.price) : 1;
      if (required === null) throw new Error('Variant unavailable');
      input.dataset.ergoMinimum = String(required); input.min = String(required); input.dataset.ergoSignature = signature;
      input.readOnly = false;
      buttons.forEach(button => button.disabled = false);
      if (buttons[0]) buttons[0].disabled = Number(input.value) <= required;
      let note = row.querySelector('[data-ergo-xboost-note]');
      if (restricted && !note) {
        note = document.createElement('p'); note.dataset.ergoXboostNote = ''; note.className = 'text-sm';
        row.querySelector('.xb_slide_cart_product_content').append(note);
      }
      if (note) note.textContent = restricted ? label(required) : '';
    } catch (_) { productCache.delete(handle); input.readOnly = false; buttons.forEach(button => button.disabled = false); }
    finally { pendingRows.delete(row); }
  }
  let xboostScheduled = false;
  const scheduleXboost = () => {
    if (xboostScheduled) return;
    xboostScheduled = true;
    requestAnimationFrame(() => {
      xboostScheduled = false;
      document.querySelectorAll('.xb_slide_cart_product').forEach(syncXboost);
    });
  };
  new MutationObserver(scheduleXboost).observe(document.body, {childList:true,subtree:true,characterData:true});
  scheduleXboost();
  document.addEventListener('click', event => {
    const button = event.target.closest('button.xb_slide_cart_product_button_quantity');
    if (!button) return;
    const row = button.closest('.xb_slide_cart_product');
    const input = row?.querySelector('input.xb_slide_cart_product_content_input');
    const first = row?.querySelector('button.xb_slide_cart_product_button_quantity');
    if (input && button === first && Number(input.value) <= Number(input.min || 1)) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', event => {
    const selector = event.target.closest('quantity-selector');
    const input = selector?.querySelector('[data-ergo-minimum]');
    if (input) queueMicrotask(() => syncMinus(input));
  });
  if (!customElements.get('ergonomik-minimum-product')) customElements.define('ergonomik-minimum-product', MinimumProduct);
  let checking = false;
  async function verifyCheckout(target) {
    if (checking) return;
    checking = true;
    const host = target.closest('form') || target.parentElement;
    let message = host.querySelector('[data-ergo-checkout-error]');
    if (!message) {
      message = document.createElement('p'); message.dataset.ergoCheckoutError = ''; message.setAttribute('role','alert');
      message.tabIndex = -1; message.className = 'text-sm'; host.prepend(message);
    }
    message.textContent = '';
    const root = window.Shopify?.routes?.root || '/';
    const getJSON = async path => {
      const response = await fetch(root + path, {cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Request failed');
      return response.json();
    };
    try {
      const cart = await getJSON('cart.js');
      if (cart.currency !== 'MXN') throw new Error('Currency unsupported');
      const lines = cart.items.filter(item => suppliers.has(String(item.vendor).trim().toUpperCase()));
      const handles = [...new Set(lines.map(item => item.handle))];
      const products = new Map(await Promise.all(handles.map(async handle => [handle, await getJSON('products/' + encodeURIComponent(handle) + '.js')])));
      const errors = [];
      for (const item of lines) {
        const variant = products.get(item.handle)?.variants.find(v => v.id === item.variant_id);
        const required = variant ? minimum(variant.price) : null;
        if (required === null) throw new Error('Invalid price');
        if (item.quantity < required) errors.push(config.error.replace('__Q__',required).replace('__TITLE__',item.product_title));
      }
      if (errors.length) { message.textContent = errors.join(' '); message.focus(); }
      else window.location.assign(root + 'checkout');
    } catch (_) { message.textContent = config.retry; message.focus(); }
    finally { checking = false; }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button[name="checkout"],input[name="checkout"],button.xb_slide_cart_button_checkout,a[href]');
    if (!target) return;
    const checkout = target.name === 'checkout' || target.matches('button.xb_slide_cart_button_checkout') || (target.tagName === 'A' && new URL(target.href,location.href).origin === location.origin && /\/checkout\/?$/.test(new URL(target.href,location.href).pathname));
    if (!checkout) return;
    event.preventDefault(); event.stopImmediatePropagation(); verifyCheckout(target);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.querySelector('[name="checkout"]') || !new URL(form.action,location.href).pathname.endsWith('/cart')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation(); verifyCheckout(event.submitter || form);
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
